module.exports = "<svg viewBox=\"0 0 14 14\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1.19 6.007h11.62v1.986H1.19z\"></path></svg>"